type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
};

const SparkleIcon = (props: Props) => {
  const {
    width = '10',
    height = '10',
    viewBox = '0 0 10 10',
    strokeColor = '#17C964',
  } = props;
  return (
    <svg
      fill="none"
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m5.00586.50293.00684.020508.04101.180664c.49416 2.202648 2.24242 3.894968 4.44238 4.284178h.00196c.00073.00316.00195.00706.00195.01172 0 .00421-.00133.00774-.00195.01074l-.00196.00098c-2.19996.38921-3.94822 2.08153-4.44238 4.28418l-.04101.18066c-.00315.01399-.00636.01976-.00684.02051l-.01563.00293c-.009-.00006-.01419-.00217-.01562-.00293l-.00684-.02051-.0332-.15527c-.47666-2.21408-2.22545-3.92198-4.432617-4.3125l-.000976-.00098c-.000348-.00231-.000977-.0049-.000977-.00781 0-.00332.000543-.00626.000977-.00879h.000976c2.207167-.39053 3.955957-2.09843 4.432617-4.312499l.0332-.155273c.00307-.014039.00644-.019882.00684-.020508l.01562-.00293c.00894-.00004.01413.002163.01563.00293z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SparkleIcon;
